import { render } from "./HsConfirmDialog.vue?vue&type=template&id=c6db508e&scoped=true"
import script from "./HsConfirmDialog.vue?vue&type=script&lang=js"
export * from "./HsConfirmDialog.vue?vue&type=script&lang=js"

import "./HsConfirmDialog.vue?vue&type=style&index=0&id=c6db508e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6db508e"]])

export default __exports__